import React from "react";

export const PromotionTableHead = (props) => {
  return (
    <React.Fragment>
      <thead>
        <tr className="super_admin_all_users_table_head">
          <th
            className="f12-400"
            style={{
              width: "10%",
              fontWeight: 400,
            }}
          >
            Business
            <br />
            ID
          </th>
          <th
            className="f12-400"
            style={{
              width: `${props.displayCss ? "11%" : "12%"}`,
              fontWeight: 400,
            }}
          >
            Business
            <br />
            Name
          </th>
          <th
            className="f12-400"
            style={{
              width: `${props.displayCss ? "15%" : "20%"}`,
              fontWeight: 400,
            }}
          >
            Primary Contact
          </th>
          <th
            className="f12-400"
            style={{
              width: `${props.displayCss ? "10%" : "10%"}`,
              fontWeight: 400,
            }}
          >
            City/Area/
            <br />
            Zip code
          </th>
          <th
            className="f12-400"
            style={{
              width: `${props.displayCss ? "10%" : "10%"}`,
              fontWeight: 400,
            }}
          >
            Business
            <br />
            Type
          </th>
          <th
            className="f12-400"
            style={{
              width: `${props.displayCss ? "15%" : "12%"}`,
              fontWeight: 400,
            }}
          >
            {props.displayActions ? "Validity" : "Promotion"}
            {props.displayActions ? "" : <br />}
            {props.displayActions ? "" : "Type"}
          </th>
          <th
            className="f12-400"
            style={{
              width: `${props.displayCss ? "11%" : "12%"}`,
              fontWeight: 400,
            }}
          >
            {props.displayActions ? "" : "Requested"}
            {props.displayActions ? "" : <br />}
            {props.displayActions ? "" : "Tag"}
          </th>
          <th
            className="f12-400"
            style={{
              width: `${props.displayCss ? "6%" : "14%"}`,
              fontWeight: 400,
            }}
          >
            Status
          </th>
          {props.displayActions ? (
            <th
              className="f12-400"
              style={{
                width: "12%",
                fontWeight: 400,
              }}
            >
              Actions
            </th>
          ) : null}
        </tr>
      </thead>
    </React.Fragment>
  );
};
